import type { Cart, CartLine } from '../types/types';

/**
 * Lines of products deleted in Shopify have no merchandise at runtime,
 * although the Storefront API schema declares it as non-null.
 */
export function isDeletedProductLine(line: CartLine) {
  return (line.merchandise as CartLine['merchandise'] | null) === null;
}

/** Cart lines, without the lines of deleted products. */
export function getCartLines(cart: Cart | null) {
  return (cart?.lines.edges ?? [])
    .map(edge => edge.node)
    .filter(line => !isDeletedProductLine(line));
}
